import { pgTable, primaryKey, text } from 'drizzle-orm/pg-core';
import { orgTableBase } from './org-id';
import { IntegrationPartner } from '../enums';
export const ApiKeys = pgTable('api_keys', {
    ...orgTableBase,
    integrationPartner: IntegrationPartner('integration_partner').notNull(),
    key: text('key').notNull(),
}, (table) => ({
    pk: primaryKey({ columns: [table.orgId, table.integrationPartner] }),
}));
//# sourceMappingURL=api-keys.js.map